module.exports = __webpack_public_path__ + "img/Logo_urba.76eaa665.jpeg";